// extracted by mini-css-extract-plugin
export default {"productGallery":"pL-z","inQuickShop":"qL-z"};